import React, { useEffect, useState }from 'react';

import getText from '../../util/ReadLongnecks';


import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


function manageAttributes (attributes?: attribute[]) {

  if (attributes) {
    return JSON.stringify(attributes);
  }
  else {
    return null;
  }
}

type attribute = {
  trait_type: string,
  value: string
};
  
type longNeck = {
  id: number,
  name: string,
  image: string,
  attributes: attribute[],
  rarity: number,
}



// type valueMap = {value: string: number[]};

// type valueMap = Map<string, number>;





function LongneckTable() {

    // const [lnstring, setlnstring] = useState("")

    const [finalLongNeckArray, setFinal] = useState<longNeck[]>([]);

    // const [rarities, setRarities] = useS

    // const [longNeckJSON, setLongneckJSON[ = useState<{}[]([])


    useEffect(() => {
      getText(setFinal);
    }, [])




    return (
      <TableContainer sx={{ maxWidth: '100%' }} component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell align="right">name</TableCell>
              {/* <TableCell align="right">image</TableCell> */}
              <TableCell align="right">imageShown</TableCell>
              <TableCell align="right">rarity</TableCell>
              <TableCell align="right">attributes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {finalLongNeckArray.map((row) => (
              <TableRow
                key={row?.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row?.id}
                </TableCell>
                <TableCell align="right">{row?.name}</TableCell>
                {/* <TableCell align="right">{row?.image}</TableCell> */}
                <TableCell align="right">{<img src={row?.image}></img>}</TableCell>
                <TableCell align="right">{row?.rarity}</TableCell>
                <TableCell align="right">{manageAttributes(row?.attributes)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

export default LongneckTable;
